import { CircularProgress } from "@mui/material"

const Loading = () => {
  return (
    <>
      <div className="flex justify-center m-4">
        <CircularProgress />
      </div>
    </>
  )
}

export default Loading
